import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { reportAssetLoadFailure } from '@shared/helpers/sentry.helper';
import { ICountry } from '@shared/interfaces/country.interface';
import { Country } from '@shared/models/country.model';
import { SessionStorage } from 'ngx-webstorage';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const COUNTRIES_URL = '/assets/data/countries.json';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  @SessionStorage() private countries: ICountry[];

  constructor(private readonly _http: HttpClient) {}

  public get(): Observable<ICountry[]> {
    return this._http.get(COUNTRIES_URL).pipe(
      map(
        (res: ICountry[]) =>
          (this.countries = res.map((c: ICountry) => new Country(c)))
      ),
      // This service is a route resolver: an error here cancels the navigation
      // outright and strands the user on a blank page. Degrade to an empty list
      // instead, and leave `countries` unset so the next navigation retries.
      catchError((error: any) => {
        reportAssetLoadFailure(error, COUNTRIES_URL);

        return of([]);
      })
    );
  }

  public resolve(): Observable<ICountry[]> {
    if (!this.countries || this.countries?.length === 0) {
      return this.get();
    }

    return;
  }
}
